import { useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ToggleButton } from "src/Components/BasicComponent";
import "./createroomtype.css";

import API from "src/API2";
import Swal from "sweetalert2";

/* ── Inline icons ───────────────────────────────────────────────── */
const Svg = ({ children, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
const IcArrow  = () => <Svg><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></Svg>;
const IcImage  = () => <Svg><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" /></Svg>;
const IcUpload = () => <Svg><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></Svg>;
const IcTag    = () => <Svg><path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></Svg>;
const IcUsers  = () => <Svg><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></Svg>;
const IcBed    = () => <Svg><path d="M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8" /><path d="M2 17h20" /><path d="M6 10V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4" /></Svg>;
const IcCash   = () => <Svg><rect x="2" y="6" width="20" height="12" rx="2" /><circle cx="12" cy="12" r="3" /><path d="M6 12h.01M18 12h.01" /></Svg>;
const IcDoc    = () => <Svg><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></Svg>;
const IcCheck  = () => <Svg><polyline points="20 6 9 17 4 12" /></Svg>;
const IcClose  = () => <Svg size={14}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></Svg>;
const IcKid    = () => <Svg size={14}><circle cx="12" cy="7" r="3" /><path d="M5 21v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v2" /></Svg>;
const IcRuler  = () => <Svg size={14}><path d="M3 21l18-18" /><path d="M5 19l3-3M9 15l3-3M13 11l3-3" /></Svg>;
const IcGrid   = () => <Svg size={14}><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></Svg>;

const CreateRoomType = () => {
  const ref = useRef();
  const navigate = useNavigate();

  const [roomType, setRoomType] = useState("");
  const [nbAdulte, setNbAdulte] = useState("");
  const [nbChildren, setNbChildren] = useState("");
  const [possibleBedNumber, setPossibleBedNumber] = useState("");
  const [nbQueenBed, setNbQueenBed] = useState("");
  const [roomSize, setRoomSize] = useState("");
  const [availibility, setAvalibility] = useState(true);
  const [description, setDescription] = useState("");
  const [images, setImages] = useState(null);
  const [nbRooms, setNbRooms] = useState("");
  const [refundable, setRefundable] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const setVal = (e, f, field) => {
    setErrors((prev) => ({ ...prev, [field]: "" }));
    f(e.target.value);
  };

  const validate = () => {
    const errs = {};
    if (!images || images.length === 0) errs.images = "At least one image is required";
    if (!roomType.trim()) errs.roomType = "Room code is required";
    else if (roomType.trim().length < 2) errs.roomType = "Room code must be at least 2 characters";
    if (!nbRooms || isNaN(nbRooms) || Number(nbRooms) < 1) errs.nbRooms = "Must be a positive number";
    if (!nbAdulte || isNaN(nbAdulte) || Number(nbAdulte) < 1) errs.nbAdulte = "Must be at least 1";
    if (nbChildren === "" || isNaN(nbChildren) || Number(nbChildren) < 0) errs.nbChildren = "Must be 0 or more";
    if (possibleBedNumber === "" || isNaN(possibleBedNumber) || Number(possibleBedNumber) < 0) errs.possibleBedNumber = "Must be 0 or more";
    if (!nbQueenBed || isNaN(nbQueenBed) || Number(nbQueenBed) < 0) errs.nbQueenBed = "Must be 0 or more";
    if (!roomSize || isNaN(roomSize) || Number(roomSize) <= 0) errs.roomSize = "Must be greater than 0";
    if (!description.trim()) errs.description = "Description is required";
    else if (description.trim().length < 10) errs.description = "Description must be at least 10 characters";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const postData = async () => {
    if (!validate()) {
      Swal.fire({
        icon: "error",
        title: "Validation error",
        text: "Please fix the highlighted fields before saving.",
      });
      return;
    }

    setSubmitting(true);
    const bodyFormData = new FormData();
    Array.from(images).forEach((e) => bodyFormData.append("pictures", e));
    bodyFormData.append("code", roomType);
    bodyFormData.append("max_adults", nbAdulte);
    bodyFormData.append("max_children", nbChildren);
    bodyFormData.append("available", availibility);
    bodyFormData.append("size", roomSize);
    bodyFormData.append("nb_queen", nbQueenBed);
    bodyFormData.append("max_additional", possibleBedNumber);
    bodyFormData.append("count", nbRooms);
    bodyFormData.append("description", description);
    bodyFormData.append("refundable", refundable);

    try {
      const res = await API.post("rooms", bodyFormData);
      if (res.data?.success && res.data?.message?.includes("already used")) {
        Swal.fire({
          icon: "warning",
          title: "Duplicate room code",
          text: "A room with this code already exists. Please use a different code.",
        });
        setErrors({ roomType: "Already used" });
      } else {
        Swal.fire({
          icon: "success",
          title: "Room type created",
          text: "Your new room type is now available.",
          confirmButtonText: "View rooms",
        }).then(() => { window.location.href = "/rooms"; });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Could not create room type. Please check your info.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  /* ── Image previews ── */
  const previews = useMemo(() => {
    if (!images) return [];
    return Array.from(images).slice(0, 5).map((f) => URL.createObjectURL(f));
  }, [images]);

  const removeImage = (idx) => {
    if (!images) return;
    const remaining = Array.from(images).filter((_, i) => i !== idx);
    if (remaining.length === 0) {
      setImages(null);
      return;
    }
    const dt = new DataTransfer();
    remaining.forEach((f) => dt.items.add(f));
    setImages(dt.files);
  };

  const renderError = (field) =>
    errors[field] ? <span className="crt-error">{errors[field]}</span> : null;

  /* ── Live preview values ── */
  const previewCode = roomType || "STD-01";
  const previewDesc = description || "Describe the comfort, view and amenities of this room.";

  return (
    <div className="crt-page">
      {/* ── Hero ── */}
      <header className="crt-hero">
        <button type="button" className="crt-back" onClick={() => navigate("/rooms")}>
          <IcArrow /> Back to room types
        </button>
        <div className="crt-hero__body">
          <div>
            <span className="crt-hero__eyebrow">Property setup</span>
            <h1 className="crt-hero__title">New room type</h1>
            <p className="crt-hero__sub">
              Define a category of rooms — capacity, bedding and policies are
              shared by every individual room of this type.
            </p>
          </div>
        </div>
      </header>

      <div className="crt-grid">
        {/* ── Form column ── */}
        <div className="crt-form">
          {/* Pictures */}
          <section className="crt-card">
            <header className="crt-card__head">
              <span className="crt-card__icon"><IcImage /></span>
              <div>
                <h3>Pictures</h3>
                <p>The first picture becomes the cover image.</p>
              </div>
            </header>

            <div
              className={`crt-dropzone ${errors.images ? "is-error" : ""} ${previews.length ? "has-files" : ""}`}
              onClick={() => ref.current.click()}
            >
              {previews.length === 0 ? (
                <div className="crt-dropzone__empty">
                  <IcUpload />
                  <strong>Click to upload pictures</strong>
                  <span>JPG or PNG · Up to 5 images</span>
                </div>
              ) : (
                <div className="crt-thumbs">
                  {previews.map((src, i) => (
                    <div key={i} className={`crt-thumb ${i === 0 ? "is-cover" : ""}`}>
                      <img src={src} alt={`Preview ${i + 1}`} />
                      {i === 0 && <span className="crt-thumb__badge">Cover</span>}
                      <button
                        type="button"
                        className="crt-thumb__remove"
                        onClick={(e) => { e.stopPropagation(); removeImage(i); }}
                        aria-label="Remove picture"
                      >
                        <IcClose />
                      </button>
                    </div>
                  ))}
                  <div className="crt-thumb crt-thumb--add">
                    <IcUpload />
                    <span>Add more</span>
                  </div>
                </div>
              )}
            </div>
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              multiple
              ref={ref}
              onChange={(e) => {
                setErrors((prev) => ({ ...prev, images: "" }));
                setImages(e.target.files);
              }}
            />
            {renderError("images")}
          </section>

          {/* Identity */}
          <section className="crt-card">
            <header className="crt-card__head">
              <span className="crt-card__icon crt-card__icon--orange"><IcTag /></span>
              <div>
                <h3>Identity</h3>
                <p>How this room type appears across the system.</p>
              </div>
            </header>
            <div className="crt-grid-2">
              <label className="crt-field">
                <span>Room code</span>
                <input
                  className={errors.roomType ? "is-error" : ""}
                  placeholder="e.g. STD-01"
                  value={roomType}
                  onChange={(e) => setVal(e, setRoomType, "roomType")}
                />
                {renderError("roomType")}
              </label>
              <label className="crt-field">
                <span>Number of rooms</span>
                <input
                  className={errors.nbRooms ? "is-error" : ""}
                  type="number"
                  min={1}
                  placeholder="How many rooms of this type"
                  value={nbRooms}
                  onChange={(e) => setVal(e, setNbRooms, "nbRooms")}
                />
                {renderError("nbRooms")}
              </label>
            </div>
          </section>

          {/* Capacity & beds */}
          <section className="crt-card">
            <header className="crt-card__head">
              <span className="crt-card__icon crt-card__icon--blue"><IcUsers /></span>
              <div>
                <h3>Capacity & bedding</h3>
                <p>Maximum guests and how the room is set up.</p>
              </div>
            </header>
            <div className="crt-grid-2">
              <label className="crt-field">
                <span>Max adults</span>
                <input
                  className={errors.nbAdulte ? "is-error" : ""}
                  type="number"
                  min={1}
                  placeholder="2"
                  value={nbAdulte}
                  onChange={(e) => setVal(e, setNbAdulte, "nbAdulte")}
                />
                {renderError("nbAdulte")}
              </label>
              <label className="crt-field">
                <span>Max children</span>
                <input
                  className={errors.nbChildren ? "is-error" : ""}
                  type="number"
                  min={0}
                  placeholder="1"
                  value={nbChildren}
                  onChange={(e) => setVal(e, setNbChildren, "nbChildren")}
                />
                {renderError("nbChildren")}
              </label>
              <label className="crt-field">
                <span>Queen beds</span>
                <input
                  className={errors.nbQueenBed ? "is-error" : ""}
                  type="number"
                  min={0}
                  placeholder="1"
                  value={nbQueenBed}
                  onChange={(e) => setVal(e, setNbQueenBed, "nbQueenBed")}
                />
                {renderError("nbQueenBed")}
              </label>
              <label className="crt-field">
                <span>Additional beds available</span>
                <input
                  className={errors.possibleBedNumber ? "is-error" : ""}
                  type="number"
                  min={0}
                  placeholder="0"
                  value={possibleBedNumber}
                  onChange={(e) => setVal(e, setPossibleBedNumber, "possibleBedNumber")}
                />
                {renderError("possibleBedNumber")}
              </label>
              <label className="crt-field">
                <span>Room size (m²)</span>
                <input
                  className={errors.roomSize ? "is-error" : ""}
                  type="number"
                  min={1}
                  placeholder="25"
                  value={roomSize}
                  onChange={(e) => setVal(e, setRoomSize, "roomSize")}
                />
                {renderError("roomSize")}
              </label>
            </div>
          </section>

          {/* Policies */}
          <section className="crt-card">
            <header className="crt-card__head">
              <span className="crt-card__icon crt-card__icon--green"><IcCash /></span>
              <div>
                <h3>Policies</h3>
                <p>Refunds and live availability.</p>
              </div>
            </header>
            <div className="crt-grid-2">
              <label className="crt-field">
                <span>Refundable</span>
                <select
                  value={String(refundable)}
                  onChange={(e) => setRefundable(e.target.value === "true")}
                >
                  <option value="false">No — non-refundable</option>
                  <option value="true">Yes — fully refundable</option>
                </select>
              </label>
              <div className="crt-field">
                <span>Availability</span>
                <div className="crt-toggle-row">
                  <ToggleButton state={availibility} setVal={setAvalibility} />
                  <span className={`crt-status crt-status--${availibility ? "on" : "off"}`}>
                    {availibility ? "Available now" : "Off market"}
                  </span>
                </div>
              </div>
            </div>
          </section>

          {/* Description */}
          <section className="crt-card">
            <header className="crt-card__head">
              <span className="crt-card__icon crt-card__icon--orange"><IcDoc /></span>
              <div>
                <h3>Description</h3>
                <p>Shown to guests on the booking site.</p>
              </div>
            </header>
            <label className="crt-field">
              <span>Description</span>
              <textarea
                className={errors.description ? "is-error" : ""}
                rows={5}
                placeholder="Describe the room — view, comfort, amenities… (at least 10 characters)"
                value={description}
                onChange={(e) => setVal(e, setDescription, "description")}
              />
              <span className="crt-counter">{description.length} characters</span>
              {renderError("description")}
            </label>
          </section>
        </div>

        {/* ── Live preview ── */}
        <aside className="crt-summary">
          <div className="crt-summary__card">
            <span className="crt-summary__eyebrow">Live preview</span>
            <h3>How it will look</h3>

            <div className="crt-preview">
              {previews[0] ? (
                <img src={previews[0]} alt="" className="crt-preview__cover" />
              ) : (
                <div className="crt-preview__cover crt-preview__cover--empty">
                  <IcImage />
                  <span>Add a cover picture</span>
                </div>
              )}
              <div className="crt-preview__body">
                <div className="crt-preview__head">
                  <span className="crt-preview__code">{previewCode}</span>
                  <span className={`crt-status crt-status--${availibility ? "on" : "off"}`}>
                    {availibility ? "Available" : "Off market"}
                  </span>
                </div>
                <p className="crt-preview__desc">{previewDesc}</p>
                <div className="crt-preview__stats">
                  <div className="crt-pstat">
                    <IcUsers />
                    <strong>{nbAdulte || 0}</strong>
                    <span>Adults</span>
                  </div>
                  <div className="crt-pstat">
                    <IcKid />
                    <strong>{nbChildren || 0}</strong>
                    <span>Children</span>
                  </div>
                  <div className="crt-pstat">
                    <IcGrid />
                    <strong>{nbRooms || 0}</strong>
                    <span>Rooms</span>
                  </div>
                  <div className="crt-pstat">
                    <IcRuler />
                    <strong>{roomSize || 0}m²</strong>
                    <span>Size</span>
                  </div>
                </div>
                <div className="crt-preview__tags">
                  <span className={`crt-tag ${refundable ? "crt-tag--green" : "crt-tag--gray"}`}>
                    {refundable ? "Refundable" : "Non-refundable"}
                  </span>
                  <span className="crt-tag crt-tag--blue">
                    <IcBed /> {nbQueenBed || 0} queen
                  </span>
                  {Number(possibleBedNumber) > 0 && (
                    <span className="crt-tag crt-tag--gray">
                      +{possibleBedNumber} extra bed{Number(possibleBedNumber) > 1 ? "s" : ""}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="crt-summary__actions">
              <button
                type="button"
                className="crt-btn crt-btn--ghost"
                onClick={() => (window.location = "/rooms")}
              >
                Cancel
              </button>
              <button
                type="button"
                className="crt-btn crt-btn--primary"
                onClick={() => !submitting && postData()}
                disabled={submitting}
              >
                {submitting ? "Saving…" : (<><IcCheck /> Save room type</>)}
              </button>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default CreateRoomType;
